export default __webpack_public_path__ + "static/media/me2.85aaa27e.jpg";